import axios from "axios";

export function listTracks() {

    const url = `/api/charts/tracks`;
    const config = {
        method: 'get',
        url,
    };
    return axios(config);
}
